export enum Locale {
  PL = "pl",
  EN = "en",
  LT = "lt",
  LV = "lv",
  RU = "ru",
  ES = "es",
  UA = "ua",
  CZ = "cz",
  FR = 'fr',
  IT = 'it',
  DE = 'de',
  PT = 'pt',
  NL = 'nl'
}

export const OANDA_LANGUAGES = ["EN", "FR", "IT", "ES", "DE", "PT", "NL"];

export const TMS_LANGUAGES = ["PL", "LV", "LT", "RU", "CZ", "UA"]
